import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgTruckFill = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M2 9.923h11.25V4H4a2 2 0 0 0-2 2v3.923ZM13.25 17v-5.615H2V17h1.256a4.502 4.502 0 0 1 8.488 0h1.506ZM22 9.923h-3.75v1.462H22V17c-.369 0-.798-.002-1.258-.005A4.502 4.502 0 0 0 16.5 14c-.612 0-1.105.122-1.5.344V6h4l3 2.714v1.21Z", fill: "currentColor" }),
    React.createElement("path", { d: "M10 18.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM16.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", fill: "currentColor" }))); };

export { SvgTruckFill as default };
